export const schemaValidateUserForgotPassword = [
  {
    id: 1,
    field: "password",
    is_in_bdd:true,
    data_type: "password_new",
    type: "field",
    max_length: 255,
    component_new:"NewInputGenericRegisterPassword",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,

    regex: "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\!\@\#\$\%\^\&\*\_\+\=\:\;\,\.\<\>]).*$", 
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "end-user-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 2,
    field: "password_repeat",
    is_in_bdd:true,
    data_type: "password_new",
    type: "field",
    max_length: 255,
    component_new:"NewInputGenericRegisterPassword",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,

    regex: "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\!\@\#\$\%\^\&\*\_\+\=\:\;\,\.\<\>]).*$", 
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "end-user-user",
    is_placeholder:true,
    occupation_new:6
  },
];